import { render, staticRenderFns } from "./StatisticsTab.vue?vue&type=template&id=6751542a"
import script from "./StatisticsTab.vue?vue&type=script&lang=js"
export * from "./StatisticsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports